import { render, staticRenderFns } from "./SimpleProductListSlider.vue?vue&type=template&id=1bbec01c"
import script from "./SimpleProductListSlider.vue?vue&type=script&lang=js"
export * from "./SimpleProductListSlider.vue?vue&type=script&lang=js"
import style0 from "./SimpleProductListSlider.vue?vue&type=style&index=0&id=1bbec01c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports